// extracted by mini-css-extract-plugin
export default {"rotate":"ConfettiPiece_rotate__Nmb5U","rotateReverse":"ConfettiPiece_rotateReverse__Kj2Z5"};